import React, { useState, useRef, useEffect, useContext } from "react";
import CreditCardImage from "../../Images/CreditCardImage.png";
import DiscoverLogoImage from "../../Images/DiscoverLogoImage.png";
import JCBLogoImage from "../../Images/JCBLogoImage.png";
import VisaLogoImage from "../../Images/VisaLogoImage.png";
import AmericanExpressLogoImage from "../../Images/AmericanExpressLogoImage.png";
import MasterCardLogoImage from "../../Images/MasterCardLogoImage.png";
import DinersClubLogoImage from "../../Images/DinersClubLogoImage.png";
import UnlockImage from "../../Images/UnlockImage.png";
import dollarImage from "../../Images/dollarImage.png";

import axios from "axios";
import { format } from "date-fns";
import Drawer from "@mui/material/Drawer";
import Lottie from "lottie-react";
import { useHistory } from "react-router-dom";
import { AppContext, useAppContext } from "../../AppContext";

import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import donemakeapp2 from "../../donemakeapp2.json";
import LottifileLoading from "../../LottifileLoading.json";
import { useTranslation } from "react-i18next";
import { MyDomain } from "../../App";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiPaper-root": {
    width:
      window.innerWidth <= 1024
        ? "90%"
        : window.innerWidth <= 1920
        ? "50%"
        : window.innerWidth <= 2560
        ? "70%"
        : window.innerWidth <= 3840
        ? "60%"
        : "50%", // Full width minus 5% padding on each side
    margin: "0 auto", // Center the modal horizontally
    maxWidth: "none", // Disable the default max width
    borderRadius: 0,
  },
}));

export default function PaymentPage({
  setCardNumber,
  cardNumber,
  setExpirtyDate,
  ExpirtyDate,
  setCVV,
  CVV,
  setNameCardHolder,
  NameCardHolder,
  setCardType,
  cardType,
  OBJForCheckOutDeliveryDetails,
  TheText,
  PromoCode,
  setPromoCode2,
  PromoCode2,
}) {
  const { t, i18n } = useTranslation();
  const {
    User,
    Token,
    setCheckIfHaveAddressToCouldClickBuy,
    CheckIfHaveAddressToCouldClickBuy,
  } = useAppContext();

  const [MyWidth, setMyWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setMyWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    // Cleanup listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const { CartAmount, setCartAmount } = useContext(AppContext);

  const user = JSON.parse(localStorage.getItem("user"));
  const [CartData, setCartData] = useState("");
  const [SaveTotalPrice, setSaveTotalPrice] = useState("");
  const [IdsOfProducts, setIdsOfProducts] = useState("");
  const history = useHistory();

  const [PAYLoading, setPAYLoading] = useState(false);

  useEffect(() => {
    //GetCartData();
  }, []);

  const GetCartData = async () => {
    setCartData([]);
    const data = {
      UserId: user?.userId,
    };
    axios
      .post(`${MyDomain}Cart/GetUserCart`, data) // replace with your API URL
      .then((response) => {
        console.log(response.data);
        const products = response.data?.products || [];
        const ids = products.map((obj) => obj.id).join(", ");
        setIdsOfProducts(ids);
        const total = products.reduce(
          (acc, product) => acc + product.PriceAfterDiscount,
          0
        );
        const filteredArray = products.map(
          ({
            id,
            name,
            image,
            price,
            discount,
            PriceAfterDiscount,
            newsCodeCat,
            isGift,
            dropDown,
            brand,
            productType,
          }) => ({
            IdOfProduct: id,
            Name: name,
            Image: image,
            PriceBeforeDiscount: price,
            Discount: discount,
            PriceAfterDiscount: PriceAfterDiscount,
            NewsCodeCat: newsCodeCat,
            IsGift: isGift,
            DropDown: dropDown,
            Brand: brand,
            ProductType: productType,
          })
        );
        setCartData(filteredArray);
        setSaveTotalPrice(total);
      })
      .catch((err) => {
        console.log(err.response.data);
      });
  };
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const CreateOrder = async () => {
    if (!User || !Token) {
      setError("User or Token is missing");
      setLoading(false);
      return;
    }
    setPAYLoading(true);
    await GetCartData();
    const today = new Date();
    const formattedDate = format(today, "MM-dd-yyyy");
    const now = new Date();
    const formattedTime = format(now, "HH:mm");
    const data = {
      Order: {
        UserId: user?.userId,
        AddressId: OBJForCheckOutDeliveryDetails.id,
        //Price: SaveTotalPrice,
        Comment: TheText,
        DateOrder: formattedDate,
        TimeOrder: formattedTime,
        ListIdOfProductsOrdered: IdsOfProducts,
        PromoCodeId: PromoCode2?.id,
        OrderStatus: 1,
        PaymentType: ChooseCashOrCard,
      },
      //products: CartData,
      OrderedAddresses: {
        UserId: user?.userId,
        FirstName: OBJForCheckOutDeliveryDetails.firstName,
        LastName: OBJForCheckOutDeliveryDetails.lastName,
        Phonenumber: OBJForCheckOutDeliveryDetails.phonenumber,
        City: OBJForCheckOutDeliveryDetails.city,
        Street: OBJForCheckOutDeliveryDetails.street,
        Building: OBJForCheckOutDeliveryDetails.building,
        Apartment: OBJForCheckOutDeliveryDetails.apartment,
        ZIPCode: OBJForCheckOutDeliveryDetails.zipCode,
        Choosing: OBJForCheckOutDeliveryDetails.choosing,
        Direction: OBJForCheckOutDeliveryDetails.direction,
      },
      Cart: {
        UserId: user?.userId,
      },
      PromoCodes: PromoCode2,
    };
    try {
      const response = await axios.post(`${MyDomain}Orders/CreateOrder`, data, {
        headers: {
          Authorization: `Bearer ${Token}`,
          "Content-Type": "application/json",
        },
      });
      setPAYLoading(false);
      console.log(response.data);
      setOpen2(true);
      setCartAmount([]);
      // Set it back to false after 5 seconds
      setTimeout(() => {
        setOpen2(false);
        history.push(`/`);
      }, 4000);
    } catch (err) {
      setPAYLoading(false);
      console.log(err);
    }
  };
  const [isValid, setIsValid] = useState(false);
  const prevExpiryRef = useRef("");

  const handleChangeExpirtyDate = (e) => {
    let value = e.target.value;

    // Remove any non-digit characters except slash
    value = value.replace(/[^\d/]/g, "");

    // Check if user is deleting (compare with previous value)
    const isDeleting = value.length < prevExpiryRef.current.length;

    // Auto-insert slash after 2 digits (only when typing, not deleting)
    if (
      !isDeleting &&
      value.length === 2 &&
      ExpirtyDate.length <= value.length
    ) {
      value = value + "/";
    }

    // Remove slash if it's in the wrong position when deleting
    if (isDeleting && value.length === 3 && value[2] === "/") {
      value = value.substring(0, 2);
    }

    // Limit to 5 characters (MM/YY)
    if (value.length > 5) {
      value = value.substring(0, 5);
    }

    setExpirtyDate(value);
    prevExpiryRef.current = value;

    // Validate MM/YY format
    const mmYYPattern = /^(0[1-9]|1[0-2])\/([0-9]{2})$/;
    setIsValid(mmYYPattern.test(value) || value.length === 0);
  };

  const handleChangeCVV = (e) => {
    const value = e.target.value;
    setCVV(value);
  };

  const handleChangeNameCardHolder = (e) => {
    const value = e.target.value;
    setNameCardHolder(value);
  };

  // Function to detect card type based on the first digits
  const detectCardType = (number) => {
    if (/^4/.test(number)) return "visa";
    if (
      /^5[1-5]/.test(number) ||
      /^22[2-9]/.test(number) ||
      /^2[3-7]/.test(number)
    )
      return "mastercard";
    if (/^3[47]/.test(number)) return "amex";
    if (
      /^65/.test(number) ||
      /^6011/.test(number) ||
      /^64[4-9]/.test(number) ||
      /^622(12[6-9]|1[3-9][0-9]|2[0-5][0-9]|[6-9][0-9]{2})/.test(number)
    )
      return "discover";
    if (/^3(?:0[0-5]|[68])/.test(number)) return "dinersclub";
    if (/^35[2-8]/.test(number)) return "jcb";
    return null;
  };

  // Function to format the card number as "XXXX XXXX XXXX XXXX"
  const formatCardNumber = (value) => {
    let numericValue = value.replace(/\D/g, "").slice(0, 16);
    return numericValue.replace(/(\d{4})/g, "$1 ").trim();
  };

  const handleChange = (e) => {
    const value = e.target.value;
    const formattedNumber = formatCardNumber(value);
    setCardNumber(formattedNumber);
    // Detect the card type
    setCardType(detectCardType(value.replace(/\s/g, "")));
  };

  // Select the correct card logo
  const getCardLogo = () => {
    switch (cardType) {
      case "visa":
        return VisaLogoImage;
      case "mastercard":
        return MasterCardLogoImage;
      case "amex":
        return AmericanExpressLogoImage;
      case "discover":
        return DiscoverLogoImage;
      case "dinersclub":
        return DinersClubLogoImage;
      case "jcb":
        return JCBLogoImage;
      default:
        return CreditCardImage; // Default card icon
    }
  };

  // const [OpenMobileDrawer, setOpenMobileDrawer] = useState(false);
  // const CloseMobileDrawerFunc = () => {
  //   setOpenMobileDrawer(!OpenMobileDrawer);
  // };
  // const ModalMobileFunc = () => {
  //   return (
  //     <div>
  //       <Drawer
  //         open={OpenMobileDrawer}
  //         onClose={CloseMobileDrawerFunc}
  //         anchor="bottom"
  //         PaperProps={{
  //           style: {
  //             height: "auto", // Height adjusts to content
  //             maxHeight: "90vh", // Optional: Limit max height
  //             overflow: "auto", // Enable scrolling
  //             padding: "16px",
  //           },
  //         }}
  //       >
  //         <div
  //           style={{
  //             display: "flex",
  //             width: "100%",
  //             //justifyContent: "flex-end",
  //             paddingTop: 20,
  //             paddingBottom: 30,
  //             flexDirection: "column",
  //           }}
  //         >
  //           <div
  //             style={{
  //               display: "flex",
  //               justifyContent: "center",
  //               alignItems: "center",
  //               flexDirection: "column",
  //               //width: 350,
  //             }}
  //           ></div>
  //         </div>
  //       </Drawer>
  //     </div>
  //   );
  // };
  const [open2, setOpen2] = useState(false);

  const handleClose2 = () => {
    setOpen2(false);
  };

  const MyModal2 = () => {
    return (
      <>
        <React.Fragment>
          <BootstrapDialog
            //onClose={handleClose2}
            aria-labelledby="customized-dialog-title"
            open={open2}
            fullWidth
            maxWidth={false} // Disable Material-UI's default width settings
          >
            <DialogTitle
              sx={{ m: 0, p: 2 }}
              id="customized-dialog-title"
            ></DialogTitle>

            <div style={{}}>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    width: "35%",
                    height: "calc(75vh - 55px)",
                    paddingTop: "1%",
                    paddingBottom: "1%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                >
                  <div
                    style={{
                      justifyContent: "center",
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <Lottie
                      //style={{ height: 40, width: 40 }}
                      animationData={donemakeapp2}
                    />
                  </div>
                  <a style={{ fontSize: 20 }}>
                    {t("profile.thedealsuccessfullydone")}
                  </a>
                </div>
              </div>
            </div>
          </BootstrapDialog>
        </React.Fragment>
      </>
    );
  };
  const [ChooseCashOrCard, setChooseCashOrCard] = useState(1); // make it 0 when work with card payment

  console.log(CheckIfHaveAddressToCouldClickBuy);
  return (
    <div
      style={{
        paddingBottom: 100,
      }}
    >
      {MyModal2()}
      <div
        style={{
          display: "flex",
          width: "100%",
          //backgroundColor: "red",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {/* <a style={{ fontSize: 14, paddingBottom: 20 }}>
          {t("profile.Doyouwantpaycashorcreditcard")}
        </a> */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-around",
            width: "100%",
          }}
        >
          {/* <button
            style={{
              display: "flex",
              //backgroundColor: ChooseCashOrCard === 1 ? "#6b21a8" : "",
              border:
                ChooseCashOrCard === 1 ? "1px solid black" : "1px solid white",
              //border: "none",
              paddingLeft: 15,
              paddingRight: 15,
              flexDirection: "column",
            }}
            onClick={() => {
              setChooseCashOrCard(1);
            }}
          >
            <a
              style={{
                fontSize: 14,
                //color: ChooseCashOrCard === 1 ? "white" : "",
              }}
            >
              {t("profile.Cash")}
            </a>

            <img
              src={dollarImage}
              alt="Card Type"
              style={{
                width: 30,
                height: 30,
                //opacity: cardType === null ? 0.5 : 1,
              }}
            />
          </button> */}
          {/* <button
            style={{
              display: "flex",
              //backgroundColor: ChooseCashOrCard === 2 ? "#6b21a8" : "",
              border:
                ChooseCashOrCard === 2 ? "1px solid black" : "1px solid white",
              paddingLeft: 15,
              paddingRight: 15,
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
            onClick={() => {
              setChooseCashOrCard(2);
            }}
          >
            <a
              style={{
                fontSize: 14,
                //color: ChooseCashOrCard === 2 ? "white" : "",
              }}
            >
              {t("profile.CreditCard")}
            </a>

            <img
              src={CreditCardImage}
              alt="Card Type"
              style={{
                width: 30,
                height: 30,
                //opacity: cardType === null ? 0.5 : 1,
              }}
            />
          </button> */}
        </div>
      </div>
      {ChooseCashOrCard === 0 ? (
        <div
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "center",
            marginTop: 20,
          }}
        >
          <a style={{ fontSize: 14 }}>
            {t("profile.pleasechoosepaymentmethod")}
          </a>
        </div>
      ) : (
        <>
          {ChooseCashOrCard === 1 ? (
            <>
              {CheckIfHaveAddressToCouldClickBuy === true ? (
                <>
                  <button
                    style={{
                      marginTop: 20,
                      backgroundColor: "#4f46e5",
                      color: "#fff",
                      border: "none",
                      //padding: "10px 20px",
                      fontSize: "16px",
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: 50,
                      borderRadius: 10,
                      opacity: PAYLoading === false ? 1 : 0.5, // Optional: make it look disabled
                      cursor: PAYLoading === false ? "pointer" : "not-allowed",
                    }}
                    disabled={PAYLoading !== false}
                    onClick={() => {
                      CreateOrder();
                    }}
                  >
                    &nbsp;&nbsp;
                    {PAYLoading ? (
                      <>
                        <Lottie
                          style={{ height: 30, width: 30 }}
                          animationData={LottifileLoading}
                        />
                      </>
                    ) : (
                      <>
                        <a style={{ fontSize: 18, fontWeight: "500" }}>
                          {t("profile.Buy")}
                        </a>
                      </>
                    )}
                  </button>
                </>
              ) : (
                <>
                  <button
                    style={{
                      marginTop: 20,
                      backgroundColor: "#f4f4f5",
                      color: "#a1a1aa",
                      fontSize: "16px",
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      height: 50,
                      borderRadius: 10,
                      //opacity: PAYLoading === false ? 1 : 0.5, // Optional: make it look disabled
                      //cursor: PAYLoading === false ? "pointer" : "not-allowed",
                      border: "1px solid #f87171" /* red border */,
                    }}
                  >
                    <a style={{ fontSize: 18, fontWeight: "500" }}>
                      {t("profile.Buy")}
                    </a>
                  </button>
                  <a style={{ fontSize: 14, color: "red" }}>
                    {t("profile.Pleaseaddthedeliveryaddresstocompletetheorder")}
                  </a>
                </>
              )}

              <div
                style={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: 20,
                  flexDirection: "column",
                }}
              >
                <a style={{ fontSize: 14 }}>
                  ({t("profile.paywhenreceivetheorder")})
                </a>
                <a style={{ fontSize: 12 }}>
                  {t("profile.Deliverywithindays")}
                </a>
              </div>
            </>
          ) : (
            <>
              <a
                style={{
                  fontWeight: "500",
                  fontSize: 16,
                  paddingBottom: 5,
                  display: "flex",
                }}
              >
                {t("profile.CreditorDebitCardNumber")}
              </a>

              <div style={{ position: "relative", width: "100%" }}>
                {/* Card Logo on the Left */}
                <img
                  src={getCardLogo()}
                  alt="Card Type"
                  style={{
                    width: 30,
                    height: 30,
                    position: "absolute",
                    left: 10,
                    top: "50%",
                    transform: "translateY(-50%)",
                    opacity: cardType === null ? 0.5 : 1,
                  }}
                />
                {/* ✅ Inline Style for Placeholder */}
                <style>
                  {`
          input::placeholder {
            color: #d4d4d8;
          }
        `}
                </style>

                {/* Input Field */}
                <input
                  type="text"
                  value={cardNumber}
                  onChange={handleChange}
                  placeholder="XXXX XXXX XXXX XXXX"
                  style={{
                    width: "100%",
                    height: 50,
                    border: "1px solid #a1a1aa",
                    padding: "5px 10px 5px 55px", // Adjusted padding for left icon space
                    borderRadius: "10px",
                    outline: "none",
                    fontSize: "16px",
                    letterSpacing: "2px",
                  }}
                  maxLength="19"
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  width: "100%",
                  paddingTop: 20,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "48%",
                  }}
                >
                  <a
                    style={{
                      fontWeight: "500",
                      fontSize: 16,
                      paddingBottom: 5,
                      display: "flex",
                    }}
                  >
                    {t("profile.ExpiryDate")}
                  </a>
                  <input
                    type="text"
                    value={ExpirtyDate}
                    onChange={handleChangeExpirtyDate}
                    placeholder={t("profile.MMYY")}
                    style={{
                      width: "100%",
                      height: 50,
                      border: "1px solid #a1a1aa",
                      padding: "5px 10px 5px 10px", // Adjusted padding for left icon space
                      borderRadius: "10px",
                      outline: "none",
                      fontSize: "16px",
                      letterSpacing: "2px",
                    }}
                    maxLength="5"
                  />
                  {/* {!isValid && ExpirtyDate.length > 0 && (
            <p style={{ color: "red" }}>Please enter a valid MM/YY format</p>
          )} */}
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "48%",
                  }}
                >
                  <a
                    style={{
                      fontWeight: "500",
                      fontSize: 16,
                      paddingBottom: 5,
                      display: "flex",
                    }}
                  >
                    CVV/CVC*
                  </a>
                  <input
                    type="text"
                    value={CVV}
                    onChange={handleChangeCVV}
                    placeholder="CVV"
                    style={{
                      width: "100%",
                      height: 50,
                      border: "1px solid #a1a1aa",
                      padding: "5px 10px 5px 10px", // Adjusted padding for left icon space
                      borderRadius: "10px",
                      outline: "none",
                      fontSize: "16px",
                      letterSpacing: "2px",
                    }}
                    maxLength="4"
                  />
                </div>
              </div>
              <div
                style={{
                  paddingTop: 20,
                }}
              >
                <a
                  style={{
                    fontWeight: "500",
                    fontSize: 16,
                    paddingBottom: 5,
                    display: "flex",
                  }}
                >
                  {t("profile.Nameoncard")}
                </a>
                <div style={{ position: "relative", width: "100%" }}>
                  {/* ✅ Inline Style for Placeholder */}
                  <style>
                    {`
          input::placeholder {
            color: #d4d4d8;
          }
        `}
                  </style>

                  {/* Input Field */}
                  <input
                    type="text"
                    value={NameCardHolder}
                    onChange={handleChangeNameCardHolder}
                    placeholder={t("profile.Fullnameasoncard")}
                    style={{
                      width: "100%",
                      height: 50,
                      border: "1px solid #a1a1aa",
                      padding: "5px 10px 5px 10px", // Adjusted padding for left icon space
                      borderRadius: "10px",
                      outline: "none",
                      fontSize: "16px",
                      letterSpacing: "2px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    //maxLength="19"
                  />
                  {CheckIfHaveAddressToCouldClickBuy === true ? (
                    <>
                      <button
                        style={{
                          marginTop: 20,
                          backgroundColor: "#4f46e5",
                          color: "#fff",
                          border: "none",
                          //padding: "10px 20px",
                          fontSize: "16px",
                          width: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          height: 50,
                          borderRadius: 10,
                          opacity: PAYLoading === false ? 1 : 0.5, // Optional: make it look disabled
                          cursor:
                            PAYLoading === false ? "pointer" : "not-allowed",
                        }}
                        disabled={PAYLoading !== false}
                        onClick={() => {
                          CreateOrder();
                        }}
                      >
                        &nbsp;&nbsp;
                        {PAYLoading ? (
                          <>
                            <Lottie
                              style={{ height: 30, width: 30 }}
                              animationData={LottifileLoading}
                            />
                          </>
                        ) : (
                          <>
                            <a style={{ fontSize: 18, fontWeight: "500" }}>
                              {t("profile.Buy")}
                            </a>
                          </>
                        )}
                      </button>
                    </>
                  ) : (
                    <>
                      <button
                        style={{
                          marginTop: 20,
                          backgroundColor: "#f4f4f5",
                          color: "#a1a1aa",
                          fontSize: "16px",
                          width: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          height: 50,
                          borderRadius: 10,
                          //opacity: PAYLoading === false ? 1 : 0.5, // Optional: make it look disabled
                          //cursor: PAYLoading === false ? "pointer" : "not-allowed",
                          border: "1px solid #f87171" /* red border */,
                        }}
                      >
                        <a style={{ fontSize: 18, fontWeight: "500" }}>
                          {t("profile.Buy")}
                        </a>
                      </button>
                      <a style={{ fontSize: 14, color: "red" }}>
                        {t(
                          "profile.Pleaseaddthedeliveryaddresstocompletetheorder"
                        )}
                      </a>
                    </>
                  )}
                </div>
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
}
